import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  posts: {
    width: '100%',
    marginTop: theme.spacing(1.2),
  },

}));

export default useStyles;
